import React, { Component } from "react";
import SubmitButton from "../common/SubmitButton";
import {
    getFormMeta,
    getFormSyncErrors,
    reduxForm,
    formValueSelector,
    registerField,
    change, Field
} from "redux-form";
import { companyValidation } from "./companyValidation";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import { messages } from "../common/Translations";
import PackageProposalModal from "./company-form/PackageProposalModal";
import Tabs from "./company-form/Tabs";
import Tab from "./company-form/Tab";
import ProfileTabContent from "./company-form/ProfileTabContent";
import CompanyInfoTabContent from "./company-form/CompanyInfoTabContent";
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import makeListMap from '../../common/listMap';
import ResetButton from "../common/ResetButton";
import RadioGroup from "../common/form/RadioGroup";
import productSellTypes from "../../common/productSellTypes";
import {subscriptionType} from "./subscriptionType";

class CompanyForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTabId: "profil",
            showModal: false,
        };

        this.portalKeywords = makeListMap();

        this.labels = {
            // Profile data
            name: props.intl.formatMessage(messages.name),
            articlesCategories: props.intl.formatMessage(
                messages.companyCategoriesFormLabel
            ),
            companyRecruiterIdHint: props.intl.formatMessage(
                messages.companyRecruiterIdDescription
            ),
            recruiterId: props.intl.formatMessage(messages.companyRecruiterId),
            portal: props.intl.formatMessage(messages.portals),
            logo: props.intl.formatMessage(messages.companyLogo),
            images: props.intl.formatMessage(messages.images),
            fileMaxSize: props.intl.formatMessage(messages.filesMaxSize),
            youtube: props.intl.formatMessage(messages.companyYouTubeText),
            // Company info
            companyGeneralInfo: this.props.intl.formatMessage(
                messages.companyGeneralInfo
            ),
            country: this.props.intl.formatMessage(messages.country),
            region: this.props.intl.formatMessage(messages.region),
            municipality: this.props.intl.formatMessage(messages.municipality),
            address: this.props.intl.formatMessage(messages.address),
            city: this.props.intl.formatMessage(messages.city),
            postalCode: this.props.intl.formatMessage(messages.postalCode),
            showAddressOnMap: this.props.intl.formatMessage(
                messages.showAddressOnMap
            ),
            companyIdentification: this.props.intl.formatMessage(
                messages.companyIdentification
            ),
            cvrNumber: this.props.intl.formatMessage(messages.cvrNumber),
            companyPhoneNumber: this.props.intl.formatMessage(
                messages.companyPhoneNumber
            ),
            companyCvrNumberDescription: this.props.intl.formatMessage(
                messages.companyCvrNumberDescription
            ),
            companyContactOptions: this.props.intl.formatMessage(
                messages.companyContactOptions
            ),
            fax: this.props.intl.formatMessage(messages.fax),
            email: this.props.intl.formatMessage(messages.email),
            companyHomePage: this.props.intl.formatMessage(
                messages.companyHomePage
            ),
            socialMediaLinks: this.props.intl.formatMessage(
                messages.socialMediaLinks
            ),
            other: this.props.intl.formatMessage(messages.other)
        };

        this.messages = {
            optional: props.intl.formatMessage(messages.optional)
        };

        //@see https://redux-form.com/6.6.1/docs/api/actioncreators.md/ -> registerField
        this.tabValidatableInputs = {
            profile: {
                // corresponds to redux form type:Field
                fields: [
                    "name",
                    "description",
                    "keywords",
                    "recruiterId",
                    "categoryIds",
                ],
                // corresponds to redux form type:FieldArray
                arrays: [],
            },
            companyInfo: {
                // corresponds to redux form type:Field
                fields: [
                    "addressId",
                    "city",
                    "postalCode",
                    "cvr",
                    "pNumber",
                    "phoneNumber",
                    "faxNumber",
                    "email",
                    "homepage",
                    "facebook",
                    "linkedin",
                    "twitter",
                    "instagram"
                ],
                // corresponds to redux form type:FieldArray
                arrays: [],
            }
        };

        this.formFields = [];
        this.formArrayFields = [];

    }

    componentDidMount() {
        this.registerInputs();
    }

    hideModal() {
        this.setState({ showModal: false });
    }

    changeActiveTab(activeTab) {
        this.setState({ activeTabId: activeTab.id });
    }

    /**
     * Resets business categories that don't suite newly selected portal in redux form state.
     * Since business categories are dependent on specific portals, it
     * - saves temporary selected business categories for each portal in class state.
     * - restores temporary business categories to redux form state if the portal was chosen again
     * So when users change the portal and add some business categories (as keywords),
     * then switch to another portal and then switch back to the previous portal again,
     * the appropriate business categories will be restored.
     *
     * @param {Event}           e
     * @param {number}          newPortalId
     * @param {number}          previousPortalId
     */
    resetBusinessCategories(e, newPortalId, previousPortalId) {
        const businessCategoryNamesForPreviousPortal = this.props.categories.map(c => c.name);

        if (!this.portalKeywords.isInitialized()) {
            this.portalKeywords.initialize({ [previousPortalId]: this.props.keywords }, previousPortalId);
        }

        this.portalKeywords.add(this.props.keywords);
        let previousPortalKeywords = this.portalKeywords.get(),
            newPortalKeywords = [...previousPortalKeywords];
        // clear business categories, leave simple keywords
        previousPortalKeywords.forEach((keyword, index) => {
            if (businessCategoryNamesForPreviousPortal.indexOf(keyword) !== -1) {
                newPortalKeywords.splice(index, 1);
            }
        });

        this.portalKeywords.select(newPortalId);
        this.portalKeywords.add(newPortalKeywords);

        this.props.dispatch(change('company', 'keywords', this.portalKeywords.get()));
    }

    /**
     * Registers redux form fields for passed inputs.
     * It's necessary at least for validation.
     * Without this approach we can't handle valitdation
     * because until the tab is selected and its fields
     * are rendered they won't be registered and redux
     * form state will not event "know" about them.
     * @see  https://redux-form.com/6.6.1/docs/api/actioncreators.md/
     *         -> registerField
     * @todo Move to separate utility if such kind of tabs for redux form will be necessary for another form (rare case)
     */
    registerInputs() {
        let tabInputs = this.tabValidatableInputs,
            tab,
            fields = this.formFields,
            arrays = this.formArrayFields;

        for (tab in tabInputs) {
            if (tabInputs.hasOwnProperty(tab) && tabInputs[tab].fields) {
                fields = fields.concat(tabInputs[tab].fields);
            }

            if (tabInputs.hasOwnProperty(tab) && tabInputs[tab].arrays) {
                arrays = arrays.concat(tabInputs[tab].arrays);
            }
        }

        fields.forEach(input => this.props.registerInput(input, 'Field'));
        arrays.forEach(input => this.props.registerInput(input, 'FieldArray'));
    }

    render() {
        let {
            portals,
            categories,
            specialBusinessCategories,
            articlesCategories,
            countries,
            regions,
            municipalities,
            addressSearchResult,
            isUpdate,
            handleSubmit,
            handleReset,
            initialValues,
            intl,
            keywords,
            keywordsExtra,
            keywordsCount,
            maxKeywordsCount,
            companyKeywordsPacks,
            isAdmin,
            errors,
            isFormDirty,
            formMeta,
            registerInput,
            companyTasks,
            companyCoverRegions
        } = this.props;

        return (
            <form onSubmit={handleSubmit} noValidate={true}>
                <PackageProposalModal
                    isModalShown={this.state.showModal}
                    hideModal={this.hideModal.bind(this)}
                    portalContacts={this.props.portalContacts}
                />
                <Tabs
                    onClick={this.changeActiveTab.bind(this)}
                    errors={errors}
                    activeTabId={this.state.activeTabId}
                    isFormDirty={isFormDirty}
                    formMeta={formMeta}
                >
                    <Tab
                        id="profil"
                        title={intl.formatMessage(messages.companyProfileData)}
                        href="#profil"
                        inputs={[...this.tabValidatableInputs.profile.fields, ...this.tabValidatableInputs.profile.arrays]}
                        registerInput={registerInput}
                    >
                        <ProfileTabContent
                            labels={this.labels}
                            messages={this.messages}
                            initialValues={initialValues}
                            isAdmin={isAdmin}
                            maxKeywordsCount={maxKeywordsCount}
                            keywords={keywords}
                            keywordsExtra={keywordsExtra}
                            keywordsCount={keywordsCount}
                            companyKeywordsPacks={companyKeywordsPacks}
                            categories={categories}
                            specialBusinessCategories={specialBusinessCategories}
                            articlesCategories={articlesCategories}
                            portals={portals}
                            onPortalChange={this.resetBusinessCategories.bind(this)}
                            regions={regions}
                            companyTasks={companyTasks}
                            companyCoverRegions={companyCoverRegions}
                        />
                    </Tab>
                    <Tab
                        id="stamdata"
                        title={intl.formatMessage(messages.companyGeneralInfo)}
                        href="#stamdata"
                        inputs={[...this.tabValidatableInputs.companyInfo.fields, ...this.tabValidatableInputs.companyInfo.arrays]}

                        registerInput={registerInput}
                    >
                        <CompanyInfoTabContent
                            labels={this.labels}
                            messages={this.messages}
                            initialValues={initialValues}
                            countries={countries}
                            regions={regions}
                            municipalities={municipalities}
                            addressSearchResult={addressSearchResult}
                            isAdmin={isAdmin}
                        />
                    </Tab>
                </Tabs>
                <div className="form-group row">
                    <div className="col-sm-12">
                        <div className="offset-sm-2">
                            <SubmitButton isUpdate={isUpdate} />
                            <ResetButton onClick={handleReset}/>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

CompanyForm = reduxForm({
    form: "company",
    validate: companyValidation,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    touchOnBlur: true,
    destroyOnUnmount: true,
    onSubmitFail: afterSubmitFail
})(CompanyForm);

CompanyForm = connect(
    state => {

        let errors = Object.assign({}, getFormSyncErrors("company")(state));
        let formMeta = Object.assign({}, getFormMeta("company")(state));
        let maxKeywordsCount = formValueSelector("company")(state, "keywordsCount");
        let keywords = formValueSelector("company")(state, "keywords");
        let keywordsExtra = formValueSelector("company")(state, "keywordsExtra");
        let portalId = formValueSelector("company")(state, "portalId");

        return {
            errors,
            formMeta,
            maxKeywordsCount,
            keywords,
            keywordsExtra,
            portalId
        };
    },
    dispatch => ({
        // alias to dispatched redux-form registerField action creator
        registerInput: (input, type) => dispatch(registerField("company", input, type)),
    })
)(CompanyForm);

export default injectIntl(CompanyForm);



// WEBPACK FOOTER //
// ./web/src/components/company/CompanyForm.jsx